import React, { useState, useEffect } from 'react'
import SideComponentContainer from '../SideComponentContainer'
import { ShotView } from '..'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { EDITOR_SHOTS_STORE } from 'store'
import styles from './ShotSideComponent.module.scss'
import { ShotSideComponentProps } from './types'

const ShotSideComponent = (props: ShotSideComponentProps) => {
  const {
    [EDITOR_SHOTS_STORE]: {
      updateShots,
      sortedSelectedShots,
      commonRelatedProjectsOfSelectedShots
    },
    projectId
  } = props

  const [showPopup, setShowPopup] = useState(false)
  const [selectedProjectsList, setSelectedProjectsList] = useState([])

  useEffect(() => {
    setSelectedProjectsList(commonRelatedProjectsOfSelectedShots)
  }, [commonRelatedProjectsOfSelectedShots])

  const handleClick = () => {
    setShowPopup(true)
  }

  const handleSubmit = () => {
    const parse = p => ({ id: p.id })

    const projectsToExclude = commonRelatedProjectsOfSelectedShots
      .filter(p => !selectedProjectsList.some(selP => selP.id === p.id))
    const projectsToAdd = selectedProjectsList
      .filter(p => !commonRelatedProjectsOfSelectedShots.some(selP => selP.id === p.id))

    const shotsToUpdate = [...sortedSelectedShots].map(s => ({
      ...s,
      relatedProjects: [
        ...s.relatedProjects.filter(p => !projectsToExclude.some(proj => proj.id === p.id)),
        ...projectsToAdd.filter(p => !s.relatedProjects.some(proj => proj.id === p.id))
      ].map(parse)
    }))
    updateShots(shotsToUpdate)
    setShowPopup(false)
  }

  const onClose = () => {
    setSelectedProjectsList(commonRelatedProjectsOfSelectedShots)
    setShowPopup(false)
  }

  return (
    <SideComponentContainer
      showPopup={showPopup}
      onPopupClose={onClose}
      onPopupSubmit={handleSubmit}
      // projectsFlatList={projectsFlatList}
      selectedProjectsList={selectedProjectsList}
      setSelectedProjectsList={setSelectedProjectsList}
      handleActionClick={handleClick}
      relatedProjects={selectedProjectsList}
      projectId={projectId}
    >
      {sortedSelectedShots.length && sortedSelectedShots.map(shot =>
        <ShotView
          key={shot.id}
          shot={shot}
          hideActions
          markIfSelected={false}
          className={styles.shotView}
        />
      )}
      {/* {shot &&
      } */}
    </SideComponentContainer>
  )
}

export default inject(EDITOR_SHOTS_STORE)(observer(ShotSideComponent))
